// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WebflowOnboarding.js: only what the Wix onboarding (WixOnboarding.css, wxo-*) has no piece for. Everything else is
   the shared wxo- styling, 1:1. Scoped under .wfo-wrapper so nothing reaches the Wix or WordPress pages. */

/* account: the e-mail code links and the notice above the button */
.wfo-wrapper .wfo-code-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: calc(-1 * var(--wxo-sp-2));
  margin-bottom: var(--wxo-sp-2);
}
.wfo-wrapper .wfo-text-btn {
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--wxo-purple);
  cursor: pointer;
}
.wfo-wrapper .wfo-text-btn:hover { text-decoration: underline; }
.wfo-wrapper .wfo-text-btn:disabled { opacity: 0.5; cursor: default; text-decoration: none; }
.wfo-wrapper .wfo-notice {
  margin-top: var(--wxo-sp-2);
  padding: 10px 14px;
  border: 1px solid var(--wxo-line);
  border-radius: 10px;
  background: var(--wxo-purple-050);
  color: var(--wxo-ink);
  font-size: 0.86rem;
  line-height: 1.45;
}

/* knowledge: the Webflow site picker (several authorized sites) */
.wfo-wrapper .wfo-site-picker { margin-bottom: var(--wxo-sp-3); }
.wfo-site-option { display: flex; align-items: center; gap: 10px; min-width: 0; width: 100%; }
.wfo-site-option img { flex: 0 0 auto; width: 18px; height: 18px; object-fit: contain; }
.wfo-site-option-name { font-weight: 600; color: #1d1530; white-space: nowrap; }
.wfo-site-option-host {
  margin-left: auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #9a93ad;
  font-size: 0.84rem;
}

/* knowledge: no site came back from the authorization */
.wfo-wrapper .wfo-no-sites {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin: var(--wxo-sp-3) 0;
  padding: 16px;
  border: 1px solid var(--wxo-line);
  border-radius: 12px;
  background: #faf9ff;
  color: var(--wxo-ink-soft);
  font-size: 0.9rem;
}
.wfo-wrapper .wfo-no-sites strong { color: var(--wxo-ink); }
.wfo-wrapper .wfo-no-sites .wxo-btn { margin-top: 6px; }

/* radar: the Webflow mark in the white core */
.wfo-wrapper .wfo-radar-core img { width: 62%; height: 62%; }

/* add to site: the one site row (live state / busy status on the right); the single button is the CTA below */
.wfo-wrapper .wfo-add-site {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: var(--wxo-sp-3) 0 var(--wxo-sp-2);
  padding: 14px 16px;
  border: 1px solid var(--wxo-line);
  border-radius: 12px;
  background: #faf9ff;
}
.wfo-wrapper .wfo-add-site.wfo-added { border-color: #cfe9d9; background: #f4fbf7; }
.wfo-wrapper .wfo-add-logo {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border: 1px solid var(--wxo-line);
  border-radius: 10px;
  background: #fff;
}
.wfo-wrapper .wfo-add-logo img { width: 24px; height: 24px; object-fit: contain; }
.wfo-wrapper .wfo-add-text { display: flex; flex-direction: column; min-width: 0; flex: 1 1; }
.wfo-wrapper .wfo-add-text strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--wxo-ink);
  font-size: 0.95rem;
}
.wfo-wrapper .wfo-add-text span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #9a93ad;
  font-size: 0.84rem;
}
.wfo-wrapper .wfo-add-btn { flex: 0 0 auto; gap: 8px; white-space: nowrap; }
.wfo-wrapper .wfo-add-done {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--wxo-ok);
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
}
.wfo-wrapper .wfo-add-busy {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--wxo-purple);
  font-size: 0.86rem;
  font-weight: 600;
  white-space: nowrap;
}
.wfo-wrapper .wfo-skip {
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-weight: 600;
  color: var(--wxo-purple);
  cursor: pointer;
}
.wfo-wrapper .wfo-skip:hover:not(:disabled) { text-decoration: underline; }
.wfo-wrapper .wfo-skip:disabled { opacity: 0.5; cursor: default; }

@media (max-width: 560px) {
  .wfo-wrapper .wfo-add-site { flex-wrap: wrap; }
  .wfo-wrapper .wfo-add-done, .wfo-wrapper .wfo-add-busy { width: 100%; justify-content: center; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/WebflowOnboarding.css"],"names":[],"mappings":"AAAA;2GAC2G;;AAE3G,mEAAmE;AACnE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,sCAAsC;EACtC,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;AACA,mCAAmC,0BAA0B,EAAE;AAC/D,sCAAsC,YAAY,EAAE,eAAe,EAAE,qBAAqB,EAAE;AAC5F;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,kEAAkE;AAClE,gCAAgC,8BAA8B,EAAE;AAChE,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,YAAY,EAAE,WAAW,EAAE;AAC7F,uBAAuB,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACvF,wBAAwB,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC/E;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;AACnB;AACA,oCAAoC,qBAAqB,EAAE;AAC3D,sCAAsC,eAAe,EAAE;;AAEvD,8CAA8C;AAC9C,mCAAmC,UAAU,EAAE,WAAW,EAAE;;AAE5D,8GAA8G;AAC9G;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;AACrB;AACA,uCAAuC,qBAAqB,EAAE,mBAAmB,EAAE;AACnF;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;AACA,iCAAiC,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACjF,6BAA6B,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE,SAAO,EAAE;AAC3F;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA,4BAA4B,cAAc,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC3E;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;AACA,8CAA8C,0BAA0B,EAAE;AAC1E,kCAAkC,YAAY,EAAE,eAAe,EAAE;;AAEjE;EACE,6BAA6B,eAAe,EAAE;EAC9C,yDAAyD,WAAW,EAAE,uBAAuB,EAAE;AACjG","sourcesContent":["/* WebflowOnboarding.js: only what the Wix onboarding (WixOnboarding.css, wxo-*) has no piece for. Everything else is\n   the shared wxo- styling, 1:1. Scoped under .wfo-wrapper so nothing reaches the Wix or WordPress pages. */\n\n/* account: the e-mail code links and the notice above the button */\n.wfo-wrapper .wfo-code-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-top: calc(-1 * var(--wxo-sp-2));\n  margin-bottom: var(--wxo-sp-2);\n}\n.wfo-wrapper .wfo-text-btn {\n  padding: 0;\n  border: none;\n  background: none;\n  font: inherit;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--wxo-purple);\n  cursor: pointer;\n}\n.wfo-wrapper .wfo-text-btn:hover { text-decoration: underline; }\n.wfo-wrapper .wfo-text-btn:disabled { opacity: 0.5; cursor: default; text-decoration: none; }\n.wfo-wrapper .wfo-notice {\n  margin-top: var(--wxo-sp-2);\n  padding: 10px 14px;\n  border: 1px solid var(--wxo-line);\n  border-radius: 10px;\n  background: var(--wxo-purple-050);\n  color: var(--wxo-ink);\n  font-size: 0.86rem;\n  line-height: 1.45;\n}\n\n/* knowledge: the Webflow site picker (several authorized sites) */\n.wfo-wrapper .wfo-site-picker { margin-bottom: var(--wxo-sp-3); }\n.wfo-site-option { display: flex; align-items: center; gap: 10px; min-width: 0; width: 100%; }\n.wfo-site-option img { flex: 0 0 auto; width: 18px; height: 18px; object-fit: contain; }\n.wfo-site-option-name { font-weight: 600; color: #1d1530; white-space: nowrap; }\n.wfo-site-option-host {\n  margin-left: auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #9a93ad;\n  font-size: 0.84rem;\n}\n\n/* knowledge: no site came back from the authorization */\n.wfo-wrapper .wfo-no-sites {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  margin: var(--wxo-sp-3) 0;\n  padding: 16px;\n  border: 1px solid var(--wxo-line);\n  border-radius: 12px;\n  background: #faf9ff;\n  color: var(--wxo-ink-soft);\n  font-size: 0.9rem;\n}\n.wfo-wrapper .wfo-no-sites strong { color: var(--wxo-ink); }\n.wfo-wrapper .wfo-no-sites .wxo-btn { margin-top: 6px; }\n\n/* radar: the Webflow mark in the white core */\n.wfo-wrapper .wfo-radar-core img { width: 62%; height: 62%; }\n\n/* add to site: the one site row (live state / busy status on the right); the single button is the CTA below */\n.wfo-wrapper .wfo-add-site {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin: var(--wxo-sp-3) 0 var(--wxo-sp-2);\n  padding: 14px 16px;\n  border: 1px solid var(--wxo-line);\n  border-radius: 12px;\n  background: #faf9ff;\n}\n.wfo-wrapper .wfo-add-site.wfo-added { border-color: #cfe9d9; background: #f4fbf7; }\n.wfo-wrapper .wfo-add-logo {\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  display: grid;\n  place-items: center;\n  border: 1px solid var(--wxo-line);\n  border-radius: 10px;\n  background: #fff;\n}\n.wfo-wrapper .wfo-add-logo img { width: 24px; height: 24px; object-fit: contain; }\n.wfo-wrapper .wfo-add-text { display: flex; flex-direction: column; min-width: 0; flex: 1; }\n.wfo-wrapper .wfo-add-text strong {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--wxo-ink);\n  font-size: 0.95rem;\n}\n.wfo-wrapper .wfo-add-text span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #9a93ad;\n  font-size: 0.84rem;\n}\n.wfo-wrapper .wfo-add-btn { flex: 0 0 auto; gap: 8px; white-space: nowrap; }\n.wfo-wrapper .wfo-add-done {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  color: var(--wxo-ok);\n  font-size: 0.9rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.wfo-wrapper .wfo-add-busy {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  color: var(--wxo-purple);\n  font-size: 0.86rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.wfo-wrapper .wfo-skip {\n  padding: 0;\n  border: 0;\n  background: none;\n  font: inherit;\n  font-weight: 600;\n  color: var(--wxo-purple);\n  cursor: pointer;\n}\n.wfo-wrapper .wfo-skip:hover:not(:disabled) { text-decoration: underline; }\n.wfo-wrapper .wfo-skip:disabled { opacity: 0.5; cursor: default; }\n\n@media (max-width: 560px) {\n  .wfo-wrapper .wfo-add-site { flex-wrap: wrap; }\n  .wfo-wrapper .wfo-add-done, .wfo-wrapper .wfo-add-busy { width: 100%; justify-content: center; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
